import React, { useState, useEffect } from "react";
import { openCookiePreferences } from "../insights";
import {
  Redirect,
  Route,
  Link,
  useParams,
  useLocation,
} from "react-router-dom";

import Translator, { __ } from "services/Translator";
import Logo from "elements/Logo";
import Slider from "react-slick";
import BrandsBar from "components/BrandsBar";

export default function Footer(props) {
  const location = useLocation();
  useEffect(() => {
    setTimeout(() => {
      // try {
      //   window.apg_f69cf96f_5984_4115_a2de_3b3301ce9bf0.init();
      // } catch (ex) {}
      try {
        window.anj_bc415b4f_1cc9_4a55_ad2d_94ef421c8ef6.init();
      } catch (ex) { }
    }, 2000);
  }, []);

  const currencyBrandSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
    variableWidth: true,
    // swipeToSlide: true,
    autoplay: true,
    // className: "center",
    // centerMode: true,
  };

  const gammingBrandSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
    variableWidth: true,
    swipeToSlide: true,
    autoplay: true,
    arrows: false,
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          variableWidth: false,
          swipeToSlide: true,
          centerMode: false,
          adaptiveHeight: false,
        },
      },
    ],
  };

  const cryptoBrandSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 5,
    variableWidth: true,
    swipeToSlide: true,
    autoplay: false,

    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 767,

        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  };
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 8,
    slidesToScroll: 8,
    variableWidth: true,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 2000,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 6,
        },
      },
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
        },
      },
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 767,

        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  };
  // const location = useLocation();
  return (
    <>
      <footer>
        <section className="footerV2">
          <div className="container-lg">
            {location.pathname != "/exclusive" && (
              <>
                <BrandsBar
                  providers={props.providers}
                  providersLoading={props.providersLoading}
                />

                <div className="footer_top">
                  <div className="row">
                    <div className="col-6 col-md-2">
                      <div className="links_section">
                        <div className="links_heading">{__("Information")}</div>
                        <ul>
                          <li>
                            <Link to="/about-us">{__("About Us")}</Link>
                          </li>
                          <li>
                            <Link to="/vip">{__("VIP")}</Link>
                          </li>
                          <li>
                            <Link to="/promotions">{__("Promotions")}</Link>
                          </li>
                          <li>
                            <Link to="/affiliates">{__("Partners")}</Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-6 col-md-2">
                      <div className="links_section">
                        <div className="links_heading">{__("Legal Info")}</div>
                        <ul>
                          <li>
                            <Link to="/terms-and-conditions">
                              {__("Terms and conditions")}
                            </Link>
                          </li>
                          <li>
                            <Link to="/privacy-policy">
                              {__("Privacy policy")}
                            </Link>
                          </li>
                          <li>
                            <Link to="/bonus-terms">{__("Bonus Terms")}</Link>
                          </li>
                          <li className="qw">
                            <Link to="/aml-policy">{__("AML Policy")}</Link>
                          </li>
                          <li>
                            <Link to="/responsible-gaming">
                              {__("Responsible Gaming")}
                            </Link>
                          </li>
                          <li>
                            <a
                              href="#cookie-preferences"
                              onClick={(e) => {
                                e.preventDefault();
                                openCookiePreferences();
                              }}
                            >
                              {__("Cookie Preferences")}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-6 col-md-2">
                      <div className="links_section">
                        <div className="links_heading">{__("Services")}</div>
                        <ul>
                          <li>
                            <Link to="/games/slots">{__("Casino Games")}</Link>
                          </li>
                          <li>
                            <Link to="/games/live-casino">
                              {__("Live Casino")}
                            </Link>
                          </li>
                          <li>
                            <Link to="/tournaments">{__("Tournaments")}</Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-6 col-md-2">
                      <div className="links_section">
                        <div className="links_heading">{__("Company")}</div>

                        <ul>
                          <li>{__("PC Play365 Ltd")}</li>
                          <li>{__("San Victor Street")}</li>
                          <li>{__("Orange Walk Town, Belize")}</li>
                          <li>
                            <a
                              className="active"
                              href="mailto:support@goldenclovercasino.com"
                            >
                              support@goldenclovercasino.com
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-12 col-md-4">
                      <>
                        <div className="license_area">
                          <div className="license_logo_area">
                            <Link
                              to="/responsible-gaming"
                              className="responsible-gaming-text-badge"
                            >
                              {__("Play Responsibly")}
                            </Link>
                          </div>

                          <div className="plus18IconArea">
                            <img
                              alt={__("18 plus only")}
                              className="plus18Icon"
                              src={require("assets/play365/images/brands/plus.webp")}
                            />
                          </div>
                        </div>
                        <p className="licenseTextArea">
                          {__(
                            "Our platform provides an exciting gaming adventure that involves risk-taking. You must be at least 18 years of age to join and participate. Please be aware that we are not liable for any breaches of local i-gaming regulations. Enjoy your time responsibly on Golden Clover Casino."
                          )}
                        </p>
                      </>
                    </div>
                    <div className="clearfix"></div>
                  </div>
                </div>
                <div className="footer_bottom_links">
                  <div className="accepted-payment-methods">
                    <div className="payment-method-item payment-method-item--applepay">
                      <img alt="Apple Pay" src={require("assets/play365/images/payment_methods/applepay.svg").default} />
                    </div>
                    <div className="payment-method-item payment-method-item--mastercard">
                      <img alt="Mastercard" src={require("assets/play365/images/payment_methods/mastercard.svg").default} />
                    </div>
                    <div className="payment-method-item payment-method-item--visa">
                      <img alt="VISA" src={require("assets/play365/images/payment_methods/visa.svg").default} />
                    </div>
                    <div className="payment-method-item payment-method-item--gpay">
                      <img alt="Google Pay" src={require("assets/play365/images/payment_methods/gpay.svg").default} />
                    </div>
                    <div className="payment-method-item payment-method-item--bank-transfer">
                      <img alt="Bank Transfer" src={require("assets/play365/images/payment_methods/bank-transfer.svg").default} />
                    </div>
                  </div>
                  <div className="responsible-gaming-logos">
                    <span className="responsible-gaming-logos__label">
                      {__("Get support:")}
                    </span>
                    <a
                      href="https://www.gamblingtherapy.org"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {__("Gambling Therapy")}
                    </a>
                    <a
                      href="https://www.gamblersanonymous.org"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {__("Gamblers Anonymous")}
                    </a>
                    <Link to="/responsible-gaming">
                      {__("Responsible Gaming")}
                    </Link>
                  </div>
                </div>
              </>
            )}

            <div className="footer_bottom">
              <div className="logo_and_social_links">
                <Logo />
                <div className="copyright_text">
                  {/* Copyright © {new Date().getFullYear()} goldenclovercasino.com */}
                  Golden Clover Casino, {new Date().getFullYear()}
                  <br />
                  All rights reserved.
                </div>
              </div>

              {props.isMobileDeviceByViewPort && (
                <div className="license_area ">
                  <div className="license_logo_area ">
                    <div
                      id="anj-bc415b4f-1cc9-4a55-ad2d-94ef421c8ef6"
                      data-anj-seal-id="bc415b4f-1cc9-4a55-ad2d-94ef421c8ef6"
                      data-anj-image-size="128"
                      data-anj-image-type="basic-small"
                    ></div>
                  </div>
                  <div className="license_text">
                    {__(
                      "Golden Clover Casino is operated by PC Play365 Ltd. Under company registration number 000049756 and having its registered address at San Victor Street, Orange Walk Town, Belize."
                    )}{" "}
                    <br />
                    {__(
                      "Golden Clover Casino is licensed in the State of Anjouan under the Computer Gaming Licensing Act 007 of 2005 under License No ALSI-202509016-FI 1"
                    )}
                  </div>
                </div>
              )}

              {!props.isMobileDeviceByViewPort && (
                <div className="license_area">
                  <div className="license_logo_area ">

                    <div id="anj-bc415b4f-1cc9-4a55-ad2d-94ef421c8ef6" data-anj-seal-id="bc415b4f-1cc9-4a55-ad2d-94ef421c8ef6" data-anj-image-size="128" data-anj-image-type="basic-small"></div>
                  </div>
                  <div className="license_text">
                    {__(
                      "Golden Clover Casino is operated by PC Play365 Ltd. Under company registration number 000049756 and having its registered address at San Victor Street, Orange Walk Town, Belize."
                    )}{" "}
                    <br />
                    {__(
                      "Golden Clover Casino is licensed in the State of Anjouan under the Computer Gaming Licensing Act 007 of 2005 under License No ALSI-202509016-FI 1"
                    )}
                  </div>
                  <div className="cryptocasinos_approved_logo"></div>
                </div>
              )}
            </div>
          </div>
        </section>
      </footer>
    </>
  );
}
